import { render, staticRenderFns } from "./Habits.vue?vue&type=template&id=c7175174&scoped=true"
import script from "./Habits.vue?vue&type=script&lang=js"
export * from "./Habits.vue?vue&type=script&lang=js"
import style0 from "./Habits.vue?vue&type=style&index=0&id=c7175174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7175174",
  null
  
)

export default component.exports